<template>
  <div class="box8">
    <h1 class="title">资深大模型专家亲授，让你少走弯路</h1>
    <div class="subject-content">
       <div class="item">
        <img class="img" src="../../../assets/coursePage/ai2/box8/li.png" alt />
        <div class="content">
          <h2>李老师 · 主讲</h2>
          <span>
            <p>· LangChain开发者</p>
            <p>· AI大模型算法专家</p>
            <p>· 传智教育AI大模型首席研究员</p>
          </span>
        </div>
       </div>
       <div class="item">
        <img class="img" src="../../../assets/coursePage/ai2/box8/yao.png" alt />
        <div class="content">
          <h2>姚老师 · 主讲</h2>
          <span>
            <p>· 大模型布道师</p>
            <p>· 大模型/多模态/AIGC前沿算法专家</p>
            <p>· 传智教育首席AIGC研究员</p>
          </span>
        </div>
       </div>
       <div class="item">
        <img class="img" src="../../../assets/coursePage/ai2/box8/yuan.png" alt />
        <div class="content">
          <h2>原老师 · 助教</h2>
          <span>
            <p>· 人工智能领域技术专家</p>
            <p>· 多年模式识别和数据挖掘开发经验</p>
           
          </span>
        </div>
       </div>
       <div class="item">
        <img class="img" src="../../../assets/coursePage/ai2/box8/zhao.png" alt />
        <div class="content">
          <h2>赵老师 · 助教</h2>
          <span>
            <p>· AIGC算法科学家</p>
            <p>· ApacheCon Asia 2022亚洲峰会特邀嘉宾</p>
          </span>
        </div>
       </div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.box8 {
  padding: 80px 0 60px;
  width: 100%;
  
  background: #6095FF;
  .title{
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 40px;
    color: #FFFFFF;
    line-height: 56px;
    text-align: center;
    font-style: normal;
  }
  .subject-content {
    padding: 48px 48px 0;
   
    .item{
      display: flex;
      background-image: url("../../../assets/coursePage/ai2/box8/bg.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      
      align-items: center;
      margin-bottom: 32px;
      padding: 8px 14px 8px 8px;
      .img{
        width: 244px;
        height: 268px;
        margin-right: 30px;
      }
      .content{
        flex: 1;
        h2{
          width: 286px;
          height: 60px;
          background: linear-gradient( 270deg, rgba(99,163,255,0) 0%, #B2DFFF 100%);
          border-radius: 30px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 32px;
          color: #FFFFFF;
          line-height: 60px;
          text-align: left;
          font-style: normal;
          margin-bottom: 18px;
          padding-left: 30px;
          box-sizing: border-box;
        }
        p{
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          font-size: 26px;
          color: #FFFFFF;
          line-height: 40px;
          margin-left: 16px;
          text-align: left;
          text-indent: -16px;
        }
      }
    }
    .item:last-child{margin-bottom: 0;}
    
  }
}
</style>
